export default __webpack_public_path__ + "static/media/tl-memecoins.f6af0e32.png";